import { useState, useEffect } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

// Simple deterministic color per username so fallback avatars look distinct.
const COLORS = ["#FF3366", "#FF4500", "#FFD700", "#2563EB", "#00BA7C", "#8B5CF6", "#F97316", "#0EA5E9"];
function colorFor(username = "") {
    let h = 0;
    for (let i = 0; i < username.length; i++) h = (h * 31 + username.charCodeAt(i)) & 0xffffffff;
    return COLORS[Math.abs(h) % COLORS.length];
}

/**
 * Renders a user's avatar image if they have one uploaded, otherwise
 * falls back to a colored circle with their initial.
 *
 * Props:
 *   username: string
 *   size: number (px)
 *   version: any value that changes to bust cache after upload
 *   className: extra classes
 *   textClass: extra classes for the fallback letter
 */
export default function UserAvatar({ username = "", size = 44, version = "", className = "", textClass = "" }) {
    const [failed, setFailed] = useState(false);
    useEffect(() => { setFailed(false); }, [username, version]);

    const src = username && !failed
        ? `${API}/api/users/${encodeURIComponent(username)}/avatar${version ? `?v=${encodeURIComponent(version)}` : ""}`
        : null;

    const initial = (username || "?").slice(0, 1).toUpperCase();
    const style = { width: size, height: size };

    return (
        <div
            data-testid={`user-avatar-${username}`}
            className={`relative border-[3px] border-ink rounded-full overflow-hidden shadow-brutal flex-shrink-0 ${className}`}
            style={{ ...style, backgroundColor: failed || !src ? colorFor(username) : "#ffffff" }}
        >
            {src && !failed ? (
                <img
                    src={src}
                    alt={username}
                    className="w-full h-full object-cover"
                    onError={() => setFailed(true)}
                />
            ) : (
                <div className={`w-full h-full flex items-center justify-center font-heading font-black text-white ${textClass}`}>
                    <span style={{ fontSize: Math.max(12, Math.floor(size * 0.45)) }}>{initial}</span>
                </div>
            )}
        </div>
    );
}
